export default "<div class=\"d-inline-block maxWidth\">\n  <p class=\"text-center\">{{ text }}</p>\n</div>\n";